/**
 * @file echart-options工具
 * @author zhuping04
 */

import _ from 'lodash';

import {ALL_COLOR} from './constants';

const titleStyle = {
    fontSize: 14,
    fontWeight: 'normal'
};

// 饼图
export interface ChartPieProps {
    options?: object,
    data?: any[],
    title?: string,
    direction?: any
}

export function createChartPie(props: ChartPieProps = {}) {
    const {title, options, data, direction} = props;

    const layout = direction === 'vertical' ? {
        center: ['50%', 150],
        legendLeft: 'center',
        legendTop: 300
    } : {
        center: [150, '50%'],
        legendLeft: 'right',
        legendTop: 'middle'
    };

    const defaultOption = {
        title: {
            text: title,
            textStyle: titleStyle
        },
        color: ALL_COLOR,
        legend: {
            orient: 'vertical',
            left: layout.legendLeft,
            top: layout.legendTop,
            align: 'left',
            data: _.map(data, 'name'),
            formatter(name: string) {
                let value = 0;
                _.each(data, item => {
                    if (item.name === name) {
                        value = item.value;
                    }
                });
                return `${name}：${value}`;
            }
        },
        series: [{
            type: 'pie',
            radius: ['80', '100'],
            center: layout.center,
            avoidLabelOverlap: false,
            label: {
                normal: {
                    show: false,
                    position: 'center'
                },
                emphasis: {
                    show: true,
                    formatter: '{b}\n{d}%',
                    fontSize: 16
                }
            },
            data
        }]
    };

    return {...defaultOption, ...options};
}